import { app } from '../../app.module'
/**
 * アカウントタグ管理モーダル用のサービス
 * @param  {Function} Restangular Restangular
 * @param  {Function} $q Promise用
 * @return {Object} オブジェクト
 */
function EditAccountTagModalCommon(Restangular, $q) {
  /**
   * getAccountById アカウントIDをキーに、アカウント情報を取得
   * @param {string} snsType SNSタイプ
   * @param {string} accountId アカウントID
   * @param {number} groupId グループID
   * @param {number} userid ユーザーID
   * @return {Object} アカウント情報
   */
  function getAccountById(snsType: string, accountId: number, groupId: number, userId: number) {
    // Promise用にdeferredオブジェクトを作成
    const deferred = $q.defer()
    const getUrl = `/account/getAccountById?group_id=${groupId}&user_id=${userId}&sns_type=${snsType}&account_id=${accountId}`

    // 選択した期間で投稿一覧を取得
    Restangular.all(getUrl)
      .getList()
      .then((result) => {
        deferred.resolve(result[0].data[0])
      })
    // promiseの結果を返す
    return deferred.promise
  }

  return {
    getAccountById: getAccountById,
  }
}

/**
 * 投稿タグ管理モーダル用のサービスを1つのサービスにオブジェクトとして格納
 * @param {Function} EditAccountTagModalFb FBアカウント取得用のサービス
 * @return {Object} サービスのオブジェクト
 */
function EditAccountTagModalService(EditAccountTagModalCommon) {
  return {
    // FB投稿タグ管理用のサービス
    common: EditAccountTagModalCommon,
  }
}

// 投稿タグ管理モーダル用のサービスを定義
app
  .factory('EditAccountTagModalCommon', EditAccountTagModalCommon)
  .factory('EditAccountTagModalService', EditAccountTagModalService)
